export const Battery = (props: React.ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 26 17" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="m11.8 2.203-3.6 6H13l-3.6 6M16.428 1H17.8a2.4 2.4 0 0 1 2.4 2.4V13a2.4 2.4 0 0 1-2.4 2.4h-3.522M25 10.597v-4.8M4.768 15.4H3.4A2.4 2.4 0 0 1 1 13V3.4A2.4 2.4 0 0 1 3.4 1h3.523"
      />
    </svg>
  );
};
